// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6410a083","455":"92193a9f","977":"d64cd1ba"}[chunkId] + ".chunk.js";
};